/**
 * @fileoverview Subcategory data source and type definitions.
 */

import { SubcategorySchema, type Subcategory } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createIdField, createJsonField, createNameField, createNumberField, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Subcategory };

export const subcategoryDataSource = createBaseDataSource<Subcategory>({
  endpoint: 'subcategory',
  searchField: 'name',
  schema: SubcategorySchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createNameField(FIELD_TYPE_WIDTHS.NAME),
    createStringField('description', 'Description', FIELD_WIDTHS.XLARGE),
    createNumberField('display_order', 'Display Order', FIELD_WIDTHS.SMALL),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAccountTrackingFields(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const subcategoryCache = getCache('subcategory');
